import React from "react"
import styled from "styled-components"

import theme from "@irati/ui/src/global/theme"
import {CompanyValue} from "@irati/companyvalues/types"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {IconButton} from "@irati/ui/src/Button"
import TrophyImg from "@irati/ui/src/Trophy"
import Flex from "@irati/ui/src/Flex"

interface Props {
  companyValue: CompanyValue
  onDelete?: () => void
}

interface StyledProps {
  archived: boolean
}

const StyledIcon = styled<StyledProps, Icon>(Icon)`
  opacity: ${({archived}) => (archived ? "0.3" : "1")};
  position: relative;
  top: 1px;
`

const CompanyValueLabel = styled<StyledProps, "div">("div")`
  background: ${({archived}) => (archived ? theme.colors.greys.lightest : theme.colors.greys.white)};
  border-radius: 3px;
  border: 1px solid ${theme.colors.greys.light};
  color: ${({archived}) => (archived ? theme.colors.greys.medium : theme.colors.greys.dark)};
  display: flex;
  align-items: center;
  gap: 8px;
  height: 30px;
  padding: 2px 6px;
  text-transform: uppercase;
  width: max-content;
  max-width: 100%;
`
const StyleAction = styled(IconButton)`
  display: flex;
`

const TextWrapper = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const CompanyValueTag: React.FC<Props> = (props) => {
  const {onDelete, companyValue} = props
  const {archived, tag, icon} = companyValue
  return (
    <CompanyValueLabel archived={archived}>
      <Flex>
        {icon?.href ? <TrophyImg isSet size="24px" src={icon.href} /> : <StyledIcon archived={archived} icon={IconTypes.label} large />}
      </Flex>
      <TextWrapper>{tag}</TextWrapper>
      {onDelete && <StyleAction onClick={onDelete} icon={IconTypes.cross} size={10} />}
    </CompanyValueLabel>
  )
}

export default CompanyValueTag
